import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePlan } from '../services/plans.api';

export function useDeletePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deletePlan(id),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: ['plans', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['plans', 'byProduct'] });
      void queryClient.removeQueries({ queryKey: ['plans', 'detail', id] });
    },
  });
}
